import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService from '../../../services/ProjectService'

type DuplicateProjectPayload = {
  organization: string
  name: string
}

export const useDuplicateProject = () => {
  const { org } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, DuplicateProjectPayload>({
    mutationKey: ['duplicate-project'],
    mutationFn: ({ organization, name }) => ProjectService.duplicateProject(organization, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects', org] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
